import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { httpGetAllNewsletters } from '../../Hooks/newsletter/newsletter.get.hooks';
import {
  NewsContainer,
  Sidebar,
  List,
  ListItem,
  Content,
  // NewsletterTitle,
  // NewsletterBody,
  Empty,
  DrawerOverlay,
  DrawerContent,
  MobileToggle,
  DrawerSidebar,
} from './News.styles';
import SelectedNewsletter from './SelectedNewsletter';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';

const NewsPage = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // console.log('newsletters', newsletters);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await httpGetAllNewsletters();
        if (!mounted) return;
        const items = Array.isArray(data) ? data : data?.newsletters || [];

        // sort by createdAt descending and auto-select newest
        items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setNewsletters(items);
        if (items.length > 0) {
          setSelected(items[0]);
        }
      } catch (err) {
        setError(err?.message || String(err));
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSelect = (item) => {
    setSelected(item);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  const renderSidebarList = () =>
    Array.isArray(newsletters) && newsletters.length > 0 ? (
      <List>
        {newsletters.map((n) => (
          <ListItem
            key={n._id || n.id || n.newsletterTitle}
            $active={selected && selected._id === n._id}
            onClick={() => {
              handleSelect(n);
              closeSidebar();
            }}
          >
            <span
              style={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.02rem',
                marginBottom: '4px',
                fontSize: '0.85rem',
                color: 'var(--orange5)',
              }}
            >
              {n?.month}
            </span>
            <br />
            {n.newsletterTitle || n.title || 'Untitled'}
          </ListItem>
        ))}
      </List>
    ) : (
      <Empty>No newsletters found.</Empty>
    );

  return (
    <div>
      <HelmetHelper
        title="News & Updates"
        description="Stay updated with the latest news and updates from Yoda Safety Services."
      />

      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'var(--danger)' }}>{error}</div>}
      <PageIntro>
        <Breadcrumbs one="Home" oneLink="/" two="News & Updates" />

        <PageHeader
          eyebrow="News"
          title="Latest News & Updates from Yoda Safety Services"
          desc="Stay informed about the latest developments, training, safety services, and workplace products from Yoda Safety Services."
        />
      </PageIntro>
      {!loading && (
        <NewsContainer>
          <Sidebar>{renderSidebarList()}</Sidebar>

          <Content>
            <SelectedNewsletter selected={selected} />
          </Content>
        </NewsContainer>
      )}

      {/* Mobile drawer toggle */}
      <MobileToggle aria-hidden={false} onClick={openSidebar}>
        Articles
      </MobileToggle>

      {isSidebarOpen && (
        <DrawerOverlay onClick={closeSidebar} role="dialog" aria-modal="true">
          <DrawerContent onClick={(e) => e.stopPropagation()}>
            <DrawerSidebar>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button onClick={closeSidebar} aria-label="Close list">
                  Close
                </button>
              </div>
              {renderSidebarList()}
            </DrawerSidebar>
          </DrawerContent>
        </DrawerOverlay>
      )}
    </div>
  );
};

export default NewsPage;

// Responsive wrapper for page intro (breadcrumbs + header)
const PageIntro = styled.div`
  /* max-width: 1400px; */
  margin: 0 auto;
  padding: var(--space-xl) var(--space-l);

  @media (min-width: 1200px) {
    padding-left: var(--space-xxxxxl);
    padding-right: var(--space-xxxxxl);
  }

  @media (max-width: 900px) {
    padding: var(--space-l) var(--space-m);
  }
`;
